var _rect, _rect2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnknown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 82,
    viewBox: "0 0 60 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 82,
    rx: 5.85714,
    fill: "#A046D3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.75,
    y: 6.75,
    width: 46.5,
    height: 66.5,
    rx: 3.75,
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8608 37.9529L21.3653 40.0991H39.3334L37.8379 37.9529H22.8608Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.479 29.8156L24.7759 30.824L22.0796 34.6964H20.8073C19.9546 34.6964 19.2136 34.2279 18.8252 33.4456C18.4368 32.6633 18.4993 31.7679 18.9949 31.0502L27.5548 18.6855V22.7609V26.834V36.8426H29.6306V27.5263V12L17.3074 29.8017C16.3633 31.1633 16.2383 32.9356 16.9793 34.4264C17.7203 35.9172 19.1868 36.8426 20.8073 36.8426H25.479V29.8156Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1952 29.8156L35.8983 30.824L38.5946 34.6964H39.8669C40.7195 34.6964 41.4606 34.2279 41.8489 33.4456C42.2373 32.6633 42.1748 31.7679 41.6793 31.0502L33.1193 18.6855V22.7609V26.834V36.8426H31.0435V27.5263V12L43.369 29.8017C44.3131 31.1633 44.4381 32.9356 43.6971 34.4264C42.956 35.9172 41.4896 36.8426 39.8691 36.8426H35.1974V29.8156H35.1952Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknown);
export default __webpack_public_path__ + "static/media/unknown.aebe82bdef3e6ed7574196ef15d2167d.svg";
export { ForwardRef as ReactComponent };